import { render, staticRenderFns } from "./InternalImagesViewer.vue?vue&type=template&id=cb4bef60&scoped=true"
import script from "./InternalImagesViewer.vue?vue&type=script&lang=js"
export * from "./InternalImagesViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4bef60",
  null
  
)

export default component.exports